import { render } from "./Chat.vue?vue&type=template&id=7ca59f84&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=7ca59f84&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-7ca59f84"

export default script